
<ul nz-menu  nzMode="inline" [nzTheme]="'light'" [nzInlineCollapsed]="navService.sidenavSmall" class="sider-menu">
      <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: items }" />
      <ng-template #menuTpl let-menus>
        @for (menu of menus; track menu) {
          <!-- visible vem da MKTPMENUACESS (loadPermissions); sem este filtro o menu inteiro do sistema aparece para qualquer usuario -->
          @if (menu.visible && !menu.hidden) {
            <!-- item sem filho e navegavel em qualquer nivel; raiz alinha com o recuo dos grupos (30) -->
            @if (!menu.children || menu.children?.length == 0) {
              <li
                nz-menu-item
                [nzPaddingLeft]="menu.level > 0 ? menu.level * 60 : 30"
                [nzDisabled]="menu.disabled"
                [nzSelected]="menu.selected"
                (click)="onItemSelected(menu)"

              >
                @if (menu.svgIconName!=null || menu.iconName!=null) {
                  <nz-icon [nzType]="menu.svgIconName!=null?'custom:'+menu.svgIconName:menu.iconName" />
                }
                <span>{{('menu.'+menu.id|translateTA)}}</span>
              </li>
            } @else {
              <li
                nz-submenu
                [nzPaddingLeft]="30"
                [nzOpen]="menu.expanded"
                [nzTitle]="'menu.'+menu.id|translateTA"
                [nzIcon]="menu.svgIconName!=null?'custom:'+menu.svgIconName:menu.iconName"
                [nzDisabled]="menu.disabled"
                (click)="onItemSelected(menu)"
              >
                <ul>
                  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }" />
                </ul>
              </li>
            }
          }
        }
      </ng-template>
    </ul>
